import { useMutation } from "@apollo/client";

import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { ProjectReviewVisitV2Screen_OverrideTimeAutoValidationDocument } from "../mutations.generated";

export function useProjectReviewVisitV2TimeReportsRoute_OverrideAutoValidation(visitId: string) {
    const [overrideTimeAutoValidationMutation, { loading, error }] = useMutation(
        ProjectReviewVisitV2Screen_OverrideTimeAutoValidationDocument,
    );

    return {
        handleOverrideTimeAutoValidation: async (reason: string | null) => {
            await overrideTimeAutoValidationMutation({
                variables: {
                    input: {
                        plannerVisitId: visitId,
                        timeProtocolAutoValidationOverriddenAt: reason ? parseDateToString(new Date()) : null,
                        timeProtocolAutoValidationOverriddenReason: reason,
                    },
                },
            });
        },
        loading,
        error,
    };
}
